import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "./AuthContext";
import GameService from "../service/gameService";
import { CONFIG } from "../helpers/constants";

const GamePlayContext = createContext();

export const GamePlayProvider = ({ children }) => {
  const { user } = useAuth();
  const gameService = new GameService(CONFIG.BASE_URL);

  const [gameUrl, setGameUrl] = useState(null);
  const [gameLoading, setGameLoading] = useState(false);
  const gamePlayRef = useRef(null);

  // Function to handle clicks outside the dialog

  useEffect(() => {
    const handleClickOutside = (event) => {
      window.location.pathanme = "/livecasino";
      if (gamePlayRef.current && !gamePlayRef.current.contains(event.target)) {
        setGameUrl(null);
      }
    };
    if (gameUrl) {
      document.addEventListener("mousedown" || "ontouch", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown" || "ontouch", handleClickOutside);
    };
  }, [gameUrl]);

  const handleGameClose = (callback) => {
    setGameLoading(false); // Reset loading state
    setGameUrl(null);
    if (callback && typeof callback === "function") {
      callback(); // Execute the callback if provided
      window.history.back();
    }
  };

  const handleGameLaunch = async (gameId, provider, callback) => {
    setGameLoading(true);
    try {
      if (!user) {
        toast.error("You must be signed in to launch a game.");
        return;
      }

      const username = user.username || "guest";
      const role = user.role || "guest";

      if (role !== "User") {
        toast.error("Only users  can launch a game.");
        return;
      }
      const url = await gameService.fetchGameUrl(gameId, username, provider);

      if (url) {
        setGameUrl(url);
        if (callback && typeof callback === "function") {
          callback(); // Execute the callback if provided
          setGameLoading(false);
        }
        // window.location.pathname = "/game-play/" + gameId;
      } else {
        toast.error("Failed to launch the game. Please try again.");
      }
    } catch (err) {
      console.error("Error launching the game:", err);
      toast.dismiss();
      toast.error("An error occurred while launching the game.");
    } finally {
      setGameLoading(false);
    }
  };

  return (
    <GamePlayContext.Provider
      value={{
        gameUrl,
        setGameUrl,
        gameLoading,
        setGameLoading,
        handleGameClose,
        handleGameLaunch,
      }}
    >
      {/* <div ref={gamePlayRef}>
        <GamePlay gameUrl={gameUrl} setGameUrl={setGameUrl} onClose={handleGameClose} />
      </div> */}
      {children}
    </GamePlayContext.Provider>
  );
};
export const useGamePlay = () => {
  const context = useContext(GamePlayContext);
  if (!context) {
    throw new Error("useGamePlay must be used within an GamePlayProvider");
  }

  return context;
};
